import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './components/home';
import LeadForm from './components/lead-form';
import Nav from './components/nav';
import SuccessPage from './components/success-page';
import SuccessPageLater from './components/success-page-later';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// 
import AppDemo from './components/MobileApp/app-demo';

ReactDOM.render(
    <BrowserRouter>
      <div>
        <Nav />
        <Switch>
          <Route exact path="/demo" component={AppDemo} />
          {/* Main Routes */}
          <Route exact path="/slides" component={App} />
          <Route exact path="/success/now" component={SuccessPage} />
          <Route exact path="/success/later" component={SuccessPageLater} />
          <Route exact path="/contact" component={LeadForm} />
          <Route exact path="/" component={Home} />
        </Switch>
      </div>
    </BrowserRouter>,
  document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
